import Axios from 'axios';
import Qs from 'qs';

export default {

  // 人员配置分页列表
  listPage(
    community_id,
    repair_attendant_name,
    repair_attendant_phone,
    repair_attendant_role,
    page,
    per_page
  ) {
    return Axios.get('/wybx/api/admin/repair_attendant', {
      params: {
        community_id,
        repair_attendant_name,
        repair_attendant_phone,
        repair_attendant_role,
        page,
        per_page
      },
      paramsSerializer(params) {
        return Qs.stringify(params);
      }
    });
  },

  // 人员配置列表
  list(
    community_id
  ) {
    return Axios.get('/wybx/api/admin/repair_attendant_all', {
      params: {
        community_id
      }
    });
  },

  // 人员配置新增
  add(
    community_id,
    property_user_id,
    repair_attendant_role
  ) {
    return Axios.post('/wybx/api/admin/repair_attendant', {
      community_id,
      property_user_id,
      repair_attendant_role
    });
  },

  // 删除人员配置
  del(
    id
  ) {
    return Axios.delete(`/wybx/api/admin/repair_attendant/${id}`);
  },

}